import useNavigation from './useNavigation';

export default function useSignInSettingNavigation() {
  return useNavigation('/settings/daily-sign-in-out');
}
